// Create+内蔵ブラウザ対応
const REMOVE_SUBCATEGORY_NUMBER = [2] //WD01
const BUILTIN_CREATIVE = "BUILTIN_CREATIVE"

const ClientHelper = {
    getLanguage : function() {
        let language = window.navigator.userLanguage||window.navigator.languages[0]

        // 中国対応
        if (language == 'zh' || language == 'zh-cn' || language.match('/^zh-hans/')) {
            return 'c2'
        }
        
        let languageId = language.substring(0, 2).toLowerCase()
        // ノルウェー対応
        if (languageId == 'nb' || languageId == 'no') {
            return 'nn'
        }

        return languageId
    },
    getOs : function() {
        // ClientHint
        if (window.navigator.userAgentData) {
            if (navigator.userAgentData.platform) {
                let platform = navigator.userAgentData.platform.toLowerCase()
                if (platform.search(/ios|ipad/) > -1) {
                    return 'ios'
                } else if (platform.search(/android/) > -1) {
                    return 'ard'
                } else if (platform.search(/windows/) > -1) {
                    return 'ws'
                } else if (platform.search(/mac/) > -1) {
                    return 'mi'
                }
            }
        }
        // User-Agent
        let userAgent = navigator.userAgent.toLowerCase()
        // if (userAgent.search(/iphone|ipad|ipod/) > -1) {
        // 20230914 iOS13以降のiPadがPCと判定されてしまうケースがあるためタッチパネルかどうかの判定条件追加
        if (userAgent.search(/iphone|ipad|ipod/) > -1 
            || userAgent.search(/macintosh/) > -1 && 'ontouchend' in document) {
            return 'ios'
        } else if (userAgent.search(/android/) > -1) {
            return 'ard'
        } else if (userAgent.search(/windows/) > -1 || userAgent.search(/win32/) > -1) {
            return 'ws'
        } else if (userAgent.search(/mac/) > -1 || userAgent.search(/macintosh/) > -1) {
            return 'mi'
        }
        return 'ws'
    },
    getUrlParam: function(param){
        let urlparams = new URLSearchParams(window.location.search)
        return urlparams.get(param)
    },
    checkLanguageCode: function (code){
        const LanguageCodeList = ['ja', 'en', 'zh', 'c2', 'nl', 'en', 'fr', 'de', 'it', 'ja', 'ko', 'pt', 'ru', 'es', 'id', 'pl', 'th', 'tr', 'sv', 'ro', 'el', 'cs', 'nn', 'da', 'fi', 'hu', 'uk', 'ms']
        if(LanguageCodeList.includes(code.toLowerCase())) {
            return code.toLowerCase()
        } else {
            return 'en'
        }
    },
    filterArticles: function (data) {
        const host = location.host
        // remove article IDs
        const removeArticles = []

        // China domain support.epson.com.cn
        if(host == 'support.epson.com.cn'){
            return data.filter(article => {
                return !removeArticles.includes(article.id)
            })
        }
        return data
    },
    sortArticles: function (data) {
        return data.sort((a,b) => {
        if(a.priority >= b.priority){
          return 1
        }else{
          return -1
        }
      })
    },
    filterCreateplusCategories: function (data, exeInfo) {
        if (exeInfo == BUILTIN_CREATIVE) {
            data.forEach((category, index) => {
                let filterSub = category.subCategories.filter(subCategory => {
                    return !REMOVE_SUBCATEGORY_NUMBER.includes(subCategory.subCategoryNumber)
                })
                data[index].subCategories = filterSub
            })
        }
        return data
    },
    filterCreateplusTemplates: function (data, exeInfo) {
        if (exeInfo == BUILTIN_CREATIVE) {
            data.filter(template => {
                return !REMOVE_SUBCATEGORY_NUMBER.includes(template.subCategoryNumber)
            })
        }
        return data
    },
}

export default ClientHelper
